(function ($) {
    $(document).ready( function() {
        initAccordion();
        clickCategory();
        initFaqSearch();

    });

    function initFaqSearch() {
        $('.faq .search-container input').bind('keypress, keydown, keyup', function() {
            var val = $(this).val();
            var patt = new RegExp(val, "i");
            $('.faq-item').hide();
            $('.faq-block').hide();
            $('.categories .title').removeClass('active');
            if (val == '') {
                return
            }
            $('.faq-item .question').each( function() {
                if (($(this).text().search(patt) >= 0)) {
                    $(this).closest('.faq-block').show();
                    $(this).closest('.faq-item').show();
                }
            })
            $('.faq-item .answer').each( function() {
                if (($(this).text().search(patt) >= 0)) {
                    $(this).closest('.faq-block').show();
                    $(this).closest('.faq-item').show();
                }
            })
        })
    }

    function clickCategory() {
        $(document).on('click', '.categories .title', function() {
            $('.faq .hello-text').hide();
            category = $(this).data('section');
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
            $(`.right-side .content .faq-block`).hide()
            $(`.right-side .content .faq-block[data-section="${category}"]`).show()
            $(`.right-side .content .faq-block[data-section="${category}"] .faq-item`).show()
        })
    }
    
    function initAccordion() {
        $(document).on('click', '.faq-item .question', function() {
            $(this).closest('.faq-item').toggleClass('active');
        })
    }
    
})(jQuery)